import React from "react";
import { render } from "react-dom";
import jQuery from "jquery";
import { Link, Redirect } from "react-router-dom";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title
    };
  }

  clickDefault = (e) => {
    e.preventDefault();
  };

  showSidebar = (e) => {
    //e.preventDefault();
    jQuery("#Sidebar").addClass("show");
    // alert("hi");
  };

  Closebtn = (e) => {
    //e.preventDefault();
    jQuery("#Sidebar").removeClass("show");
  };

  refreshdata = () => {
    location.reload();
  };

  render() {
    return (
      <div className="container HeaderContainer">
        <div className="row heading-column">
          <div className="col-12 title-column">
            <a onClick={this.showSidebar} className="btn-toggle">
              <i className="fa fa-bars"></i>
            </a>
            <h1>{this.state.title}</h1>
          </div>
        </div>
        <div className="Sidebar" id="Sidebar">
          <div className="SidebarInner">
            <span className="closeBtn" id="closeBtn" onClick={this.Closebtn}>
              <i className="fa fa-close"></i>
            </span>
            <ul>
              <li>
                <Link to="/">
                  <i className="fa fa-home"></i>
                  <span>Home</span>
                </Link>
              </li>
              <li>
                <Link to="/globaldashboard">
                  <i className="fa fa-dashboard"></i>
                  <span>Global Dashboard</span>
                </Link>
              </li>
              <li>
                <Link to="/globaldata">
                  <i className="fa fa-globe"></i>
                  <span>Global List Data</span>
                </Link>
              </li>
              <li>
                <Link to="/indiadata">
                  <i className="fa fa-flag-o"></i>
                  <span>India Data</span>
                </Link>
              </li>
              <li>
                <Link to="/usadata">
                  <i className="fa fa-flag-o"></i>
                  <span>USA Data</span>
                </Link>
              </li>
              <li>
                <Link to="/vaccineIN">
                  <i className="fa fa-medkit"></i>
                  <span>India's Vaccination Data</span>
                </Link>
              </li>
              <li>
                <a href="https://www.cowin.gov.in/home" target="_blank">
                  <i className="fa fa-id-badge"></i>
                  <span>India's Vaccine Registation </span>
                </a>
              </li>
              <li>
                <Link to="/">
                  <i className="fa fa-sign-out"></i>
                  <span>LogOut </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
